/**
 * Bezpieczne zdarzenia Meta Pixel: nie wybucha, gdy fbq nie istnieje
 * (adblock, środowisko dev). Zdarzenia standardowe Meta:
 * CompleteRegistration (rejestracja), StartTrial (aktywacja trialu),
 * Subscribe (subskrypcja).
 */
export function trackMetaEvent(eventName, params) {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', eventName, params || {});
    }
  } catch {
    // analityka nigdy nie może zepsuć UX
  }
}
